export default {"src":"/_next/static/media/CECA_ICONOS_Hogar_02.8abdf3b1.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};